<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Select from "@/components/c-select";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import moment from 'moment'
import { incomeExpenseReportService } from "../../../../services/reportservice/incomeexpensereport.service.js";


/* eslint-disable no-console */
export default {
  page: {
    title: "Income Summary Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Layout, 
    PageHeader, 
    Button,
    Select, 
    Input
  },
  data() {
    return {
      title: "Income Summary Report",
      data: [],
      date: '',
      projects: {},
      projectExpense: 0,
      officeExpense: 0,
      projectName: 'លំនៅឋាន អេច សែនសុខ (RHSS)',
      user: JSON.parse(localStorage.getItem('user')),

      dataProjectId: 0,
      s_date: '',
      e_date: '',
      
    };
  },
  mounted() {
    //this.loadingData(this.$route.params.id);
    this.loadingData();
    
  },
  methods: {
    
    loadingData: function() {
      this.fetchingStats = false;
      incomeExpenseReportService.getExpenseDaily()
        .then(response => {
            this.fetchingStats = true;
            this.data = response.data.result;
            this.date = response.data.date;
            this.dataDate = response.data.date;
            this.projects = response.data.projects;
            this.officeExpense = response.data.smmary.office_expense;
            this.projectExpense = response.data.smmary.project_expense;
            this.projecttName = response.data.project_name;
        });
    },
   
    submitSearch: function() {
      let param = '?project_id='+this.dataProjectId+
        '&s_date='+this.s_date + 
        '&e_date='+this.e_date;
        
      incomeExpenseReportService.getExpenseDaily(param)
        .then(response => {
            this.data = response.data.result;
            this.date = response.data.date;
            this.officeExpense = response.data.smmary.office_expense;
            this.projectExpense = response.data.smmary.project_expense;
            this.projectName = response.data.project_name.name +'('+response.data.project_name.name_en+')';
      });
    },
    dateFormat: function(value){
      return moment(String(value)).format('DD/MM/YYYY');
    },
    discountPrice(price, discount, dis_type) {
        let total = 0;
        if(dis_type==1){
          total = price * discount / 100;
        }else{
          total = discount
        }
        return total
    },
    formatCurrency(value) {
      if(value == 0 ){
        return 0;
      }
      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    numberFormat(value) {
      if(!value){
        return '';
      }
      let sign = '';
      let decimal = '.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    print() {
      window.print();
    },
    total(column) {
      return this.data.reduce(function (sum, item) {
        return sum + item[column];
      }, 0)
    },
  }
};

</script>

<template>
  <Layout>
    <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="$t('report.text')+$t('report.income_expense.income-summary')" />
      <div id="print-area">
        <!-- <center> -->
          <div class="row search-area">
              
              <div class="col-sm-2">
                <label>{{$t('project.text')}}</label>
                <Select
                    :id="'id'"
                    :text="'label'"
                    :editable="true"
                    :list="{data: this.projects}"
                    v-model="dataProjectId"
                    /> 
                </div>
                <div class="col-sm-2">
                    <label>{{$t('general.start-date')}}</label>
                    <Input 
                    :type="'date'"
                    :id="'start_date'"
                    v-model="s_date"
                    /> 
                </div>
                <div class="col-sm-2">
                    <label>{{$t('general.end-date')}}</label>
                    <Input 
                    :type="'date'"
                    :id="'end_date'"
                    v-model="e_date"
                    /> 
                </div>
              <div class="col-sm-2">
                <label class="text-white">{{$t('report.text')}}</label>
                <Button v-bind:icon="'bx bx-search'"
                  @click="submitSearch()" 
                  v-bind:buttonType="'button'"
                  v-bind:variant="'primary'"
                  v-bind:title="$t('general.search')" 
                />
              </div>
          </div>
          <div class="col dblack box-a4l">
            <table width="100%" class="content-general bottom">
              <tr>
                <td width="9%"><p>&nbsp;</p></td>
                <td width="50%"><p>&nbsp;</p></td>
                <td width="35%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                <td>
                  <p class="khb h4"><b>ក្រុមហ៊ុនលំនៅឋាន<span class="g-color"> អេចស៊ី </span>ឯ.ក</b></p>
                  <p class="enb h5"><b>LOMNOV THAN <span class="g-color">HC</span> CO., LTD</b></p>
                  <p class="khs h8">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                  <p class="khs h8">ទូរស័ព្ទលេខៈ 092 685 009 | 098 685 009 Email: account@h-residence.net</p>
                </td>
                <td class="">
                    <h4 class="khb"><u>{{$t('report.text')+$t('report.income_expense.income-summary')}}</u></h4>
                    <!-- <p class="khb"><u>គម្រោង: {{this.projectName}}</u></p> -->
                    <p class="khb"><u>កាលរិច្ឆេទ: {{this.dateFormat(date)}}</u></p>
                </td>
              </tr>
              
            </table>
            <br/>
            <table class="content-general h8 project-sumary-table report-table" width="100%">
              
                <tr class="thead">
                  <th rowspan="2">{{$t('general.number')}}</th>
                  <th rowspan="2">{{$t('project.text')}}</th>
                  <th rowspan="2">{{$t('report.sale-detail.booked')}}</th>
                  <th colspan="3">{{$t('report.income_expense.income-unit-payment')}}</th>
                  <th colspan="3">{{$t('report.income_expense.othter-income')}}</th>
                  <th rowspan="2">{{$t('report.income_expense.total_income')}}</th>
                </tr>
                <tr class="thead">
                  <th>{{$t('sale.interest')}}</th>
                  <th>{{$t('general.principal')}}</th>
                  <th>{{$t('general.penalty')}}</th>
                  <th rowspan="2">{{$t('report.income_expense.name-transfer-service')}}</th>
                  <th rowspan="2">{{$t('report.income_expense.payment-date-exchange-service')}}</th>
                  <th rowspan="2">{{$t('report.income_expense.partner-extension-service')}}</th>

                </tr>
               
                <tbody>
                   
                </tbody>
            </table>
            <br>

       
            <div class="row mt-3 report-table">
              <div class="col">
                <center>
                  <p class="mt-4">បានពិនិត្យនិងឯកភាព<br>នាយកផ្នែកហិរញ្ញវត្ថុ</p>
                  <p class="mt-5">លឹម ទ្រី</p>
                  <p>ថ្ងៃខែឆ្នាំ...........................</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p class="mt-4">ត្រួតពិនិត្យដោយ<br>ប្រធានគ្រប់គ្រងទូទៅ</p>
                  <p class="mt-5"></p>
                  <p>ថ្ងៃខែឆ្នាំ...........................</p>

                </center>
              </div>
              <div class="col">
                <center>
                  <p class="mt-4">ត្រួតពិនិត្យដោយ<br>ប្រធានគណនេយ្យ</p>
                  <p class="mt-5"></p>
                  <p>ថ្ងៃខែឆ្នាំ...........................</p>

                </center>
              </div>

              <div class="col">
                <center>
                  <p class="mt-4">កត់ត្រាដោយ<br>គណនេយ្យករ</p>
                   <p class="mt-5">{{this.user.name}}</p>
                  <p>ថ្ងៃខែឆ្នាំ...........................</p>

                </center>
              </div>
             
            </div>
          </div>  
        <!-- </center> -->
      </div>
    <!-- end row -->
  </Layout>
</template>